import gsil from '../images/logo_gsil.svg';
import ueco from '../images/logo_ueco.png';

export default function Footer() {
  const goToGsil = () => window.open('https://gsil.kr/');
  const goToUeco = () => window.open('http://ueco.or.kr/');

  return (
    <div className='w-full mt-auto py-15 md:py-[37px] h-64 md:h-[160px] flex justify-evenly bg-[#2f2f35]'
    // style={{ position: "fixed", bottom: "0" }}
    >
      <img className='w-46 md:w-[115px]' src={gsil} alt='gsil' onClick={goToGsil} />
      <img className='py-6 w-53 md:w-[132px]' src={ueco} alt='ueco' onClick={goToUeco} />
    </div>
  );
}
